import Sonda from '@gc-npm/utils.monitoring.sonda';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import Request from '@gc-npm/utils.fetch';
import { calculateHeaderParams } from '@gc-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gc-npm/utils.enums.environment';

const PATH = '/api/v1/config-controller/selection';
const EVENT_NAME = {
  CLIENT: 'SSR_CONFIG.SELECTION_CLIENT',
  OPEN: 'SSR_CONFIG.SELECTION',
};
const METHOD = 'GET';

const orderParams = (params) => {
  try {
    return encodeURIComponent(JSON.stringify(params.sort((a, b) => a?.id.localeCompare(b?.id))))
  } catch {
    return encodeURIComponent(JSON.stringify(params))
  }
}

export const selection = ({
  context,
  build = false,
  onSuccess,
  idFront = 'TC',
  ids,
  urlParamsSelection,
  selectedIds,
  clientInfo = null,
  sessionZone,
  oldMultibundleOptions,
  urlParams,
  extraLines,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: context.userType ? EVENT_NAME.CLIENT : EVENT_NAME.OPEN,
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });

  try {
    const { 'ssr-backend': connectionData, name } = context.environment;
    let { endpoint: host } = connectionData;
    if (name === 'local') {
      // mientras desarrollamos
      host = 'http://127.0.0.1:8080';
    }
    const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_BACKEND, context);
    // const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_TVCONFIG, context);
    let params = '';
    if (ids) {
      const idsParam = orderParams(ids);
      params += `&ids=${idsParam}`
    }
    if (urlParamsSelection) {
      const urlParamsSelectionParam = orderParams(urlParamsSelection);
      params += `&urlParamsSelection=${urlParamsSelectionParam}`;
    }
    if (selectedIds) {
      const selectedIdsParam = orderParams(selectedIds);
      params += `&selectedIds=${selectedIdsParam}`;
    }

    if (clientInfo) {
      const clientInfoParam = encodeURIComponent(JSON.stringify(clientInfo));
      params += `&clientInfo=${clientInfoParam}`;
    }
    if (sessionZone) {
      params += `&sessionZone=${sessionZone}`;
    }
    if (oldMultibundleOptions) {
      const oldMultibundleOptionsParam = orderParams(oldMultibundleOptions);
      params += `&oldMultibundleOptions=${oldMultibundleOptionsParam}`;
    }
    if (urlParams?.debugServer) {
      params += `&urlParamsDebug=${urlParams.debugServer}`;
    }
    if (urlParams?.directBuyProcess) {
      params += `&directBuyProcess=${Boolean(urlParams.directBuyProcess)}`;
    }
    if (extraLines) {
      params += `&extraLines=${JSON.stringify(extraLines)}`;
    }

    const URL_API = `${host}${PATH}?${idRequest}${params}`;
    const request = new Request({
      method: METHOD,
      endpoint: URL_API,
      data: '',
      build,
      headers: {
        ...headers2Use,
      },
      onError: () => {
        return null;
      },
      sonda,
      onSuccess: (response) => {
        return onSuccess({ response });
      },
    });
    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
export default selection;
